import { bootstrapApplication } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { amplifyConfig } from './app/amplify-config';

Amplify.configure(amplifyConfig);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
